import React, { FC, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { MDSText, MDSTextVariant, MDSTextWeight, MDSButton, MDSButtonVariant } from "@/mds";
import {
  WizardContentWrapper,
  StepTitle,
  StepContent,
  FooterContainer,
} from "@/components/onboarding/components/welcome-wizard/onboarding-steps.styles";
import { electronModule } from "@/modules/electron";

type Props = {
  onClose?: () => void;
};

export const OnboardingPermissionsRestartScreen: FC<Props> = observer(({ onClose }) => {
  const handleRestart = useCallback(async () => {
    onClose?.();

    if (electronModule.restartApp) {
      await electronModule.restartApp();
      return;
    }

    await electronModule.closeWindow();
  }, [onClose]);

  return (
    <WizardContentWrapper>
      <StepTitle>Restart Mem to finish setup</StepTitle>
      <StepContent>
        <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
          To complete setup, restart Mem
        </MDSText>
      </StepContent>

      <FooterContainer align="flex-end">
        <MDSButton variant={MDSButtonVariant.Contrast} onClick={handleRestart}>
          Restart Mem
        </MDSButton>
      </FooterContainer>
    </WizardContentWrapper>
  );
});
